import React from "react";
import { Clock3, ShieldCheck } from "lucide-react";

export function RetentionNotice({ onAccept }) {
  return (
    <main className="min-h-screen bg-cream flex flex-col items-center justify-center px-4 py-10" data-testid="retention-notice" translate="yes">
      <img
        src="/you-voice-brand.png?v=20260811"
        alt="You Voice"
        className="onboarding-brand"
        data-testid="retention-notice-brand"
      />
      <section
        className="w-full max-w-xl rounded-3xl border border-edge bg-white p-6 sm:p-8 shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="retention-notice-title"
        aria-describedby="retention-notice-description"
      >
        <div className="w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-5">
          <Clock3 size={28} />
        </div>
        <h1 id="retention-notice-title" className="font-display text-3xl sm:text-4xl font-semibold text-ink">
          Durata dei tuoi messaggi
        </h1>
        <div id="retention-notice-description" className="mt-4 space-y-3 text-sm sm:text-base leading-relaxed text-ink/80">
          <p>
            I messaggi che pubblichi su You Voice, inclusi commenti e relativi allegati,
            vengono conservati nel social per <strong>un anno dalla pubblicazione</strong>.
          </p>
          <p>
            Trascorso un anno, il sistema li cancellerà automaticamente dal social.
            Potrai comunque eliminarli personalmente in qualsiasi momento prima della scadenza.
          </p>
        </div>
        <div className="mt-5 flex items-start gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 p-3 text-xs sm:text-sm text-emerald-900">
          <ShieldCheck size={18} className="shrink-0 mt-0.5" />
          <span>Questo avviso viene mostrato una sola volta per questa identità.</span>
        </div>
        <button
          type="button"
          onClick={onAccept}
          className="big-cta w-full mt-6"
          data-testid="retention-notice-accept"
        >
          Ho capito, entra nel social
        </button>
      </section>
    </main>
  );
}
